import SharedLeadsLoader from "../shared-leads-loader/SharedLeadsLoader";



const SharedLeads = () => {

  return (
      <SharedLeadsLoader
        title={"Briefs transmis"}
        showMenu={true}
        limit={null}
        paginateResults={true} 
        height={'80%'}
        />
  );

}

export default SharedLeads;
